export const clpLabelDropDownLearnMoreButtonText = "Nkb";
export const clpLabelDropDownLearnMoreButtonToolTipText = "Okb";
export const clpLabelCannotChangeLabelModalTitle = "Pkb";
export const clpLabelCannotChangeLabelModalSubtext = "Qkb";
export const clpLabelCannotChangeLabelWithCloudAttachment = "Rkb";
export default {clpLabelDropDownLearnMoreButtonText,clpLabelDropDownLearnMoreButtonToolTipText,clpLabelCannotChangeLabelModalTitle,clpLabelCannotChangeLabelModalSubtext,clpLabelCannotChangeLabelWithCloudAttachment};